import React from 'react';
import Card from 'react-bootstrap/Card';
import styles from '../styles/elements/FloatMessage.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faExclamationCircle} from '@fortawesome/free-solid-svg-icons';

const FloatMessage = (props) => {

    const {message} = props;

    return (
        <div className={styles.back}>
            <section className={styles.root}>
                <Card className="w-100 px-md-5 py-md-3 p-0">
                    <Card.Body>
                        <Card.Title>
                            <FontAwesomeIcon icon={faExclamationCircle} className="me-2" height="16" width="16" />
                            {message}
                        </Card.Title>
                    </Card.Body>
                </Card>
            </section>
        </div>
        
    );
}

export default FloatMessage;